import jwt_decode from "jwt-decode";

export function getDecodedToken() {
  try {
    const token = localStorage.getItem("token");
    if (!token) return null;
    return jwt_decode(token);
  } catch {
    return null;
  }
}
